// @sheerid/jslib doesn't polyfill for IE11 currently
import 'whatwg-fetch';
import 'url-search-params-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// SheerID stuff
import { setOptions, overrideComponent, setMetadata } from '@sheerid/jslib';
import { defaultOptions } from './options';

import { StepStudentPersonalInfoComponent } from './components/StepStudentPersonalInfo/StepStudentPersonalInfoComponent';
import { StepDocUploadComponent } from './components/StepDocUpload/StepDocUploadComponent';
import { StepSuccessComponent } from './components/StepSuccess/StepSuccessComponent';
import { StepPendingComponent } from './components/StepPending/StepPendingComponent';
import { StepErrorComponent } from './components/StepErrorComponent';
import { getQueryParamsByName } from './metadataQueryString';

setOptions(defaultOptions);

overrideComponent("StepStudentPersonalInfoComponent", StepStudentPersonalInfoComponent);
overrideComponent("StepDocUploadComponent", StepDocUploadComponent);
overrideComponent("StepSuccessComponent", StepSuccessComponent);
overrideComponent("StepPendingComponent", StepPendingComponent);
overrideComponent("StepErrorComponent", StepErrorComponent);

const qs_value = getQueryParamsByName("qs") || '';
setMetadata({ qs: qs_value });
setMetadata({ affiliationType: 'STUDENT_FULL_TIME,STUDENT_PART_TIME' });

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
